import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { AppletModuleHdrModel } from '../../../../../models/aggregates/applet/applet_module_hdr.model';

@Injectable({providedIn: 'root'})
export class AppletModuleHdrService extends BaseApiTemplateService<AppletModuleHdrModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      'module-applet-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'module-applet-hdrs/backoffice-ep';
    this.httpClient = http;
  }
}
